import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import Videobg from './Videobg';
import VideoTitle from './VideoTitle';

const OMDB_KEY = process.env.REACT_APP_OMDB_KEY;

const MainContainer = () => {

    const movies=useSelector(store => store.movie?.nowPlayingMovies);
    const [omdbPlot, setOmdbPlot] = useState(null);

    const heroId = movies?.[0]?.id;
    useEffect(() => {
      if (typeof heroId === 'string' && heroId.startsWith('tt')) {
        fetch(`https://www.omdbapi.com/?i=${heroId}&plot=short&apikey=${OMDB_KEY}`)
          .then((r) => r.json())
          .then((d) => { if (d?.Plot && d.Plot !== 'N/A') setOmdbPlot(d.Plot); })
          .catch(() => {});
      } else {
        setOmdbPlot(null);
      }
    }, [heroId]);

    if (!movies) {
      return (
        <div className='relative w-full h-screen bg-black overflow-hidden'>
          <div className='absolute inset-0 bg-gradient-to-r from-neutral-800 to-neutral-900 animate-pulse'></div>
          <div className='absolute bottom-1/3 left-12 space-y-4'>
            <div className='h-12 w-80 bg-neutral-700 rounded animate-pulse'></div>
            <div className='h-4 w-96 bg-neutral-700 rounded animate-pulse'></div>
            <div className='h-4 w-72 bg-neutral-700 rounded animate-pulse'></div>
          </div>
        </div>
      );
    }
    if (movies.length === 0) return null;

    const mainMovie=movies[0];
    const { original_title, overview, id, poster_path, year } = mainMovie;
    const displayOverview = omdbPlot || overview || (year ? `Released: ${year}` : '');

    return (
    <div className='relative bg-black'>
      <Videobg movieId={id} posterPath={poster_path}/>
      <VideoTitle title={original_title} overview={displayOverview}/>
    </div>
  )
}

export  default MainContainer